const WIDGET_STORAGE_KEY = 'admin_widgets';
const SYNC_INTERVAL = 30 * 60 * 1000; // 30 minutes
const LAST_SYNC_KEY = 'widgets_last_sync';

export const loadPersistedWidgets = (userId = null) => {
  try {
    const storageKey = userId ? `${WIDGET_STORAGE_KEY}_${userId}` : WIDGET_STORAGE_KEY;
    const persistedWidgets = localStorage.getItem(storageKey);
    return persistedWidgets ? JSON.parse(persistedWidgets) : [];
  } catch (error) {
    console.error('Error loading persisted widgets:', error);
    return [];
  }
};

export const saveWidgets = (widgets, userId = null) => {
  try {
    const storageKey = userId ? `${WIDGET_STORAGE_KEY}_${userId}` : WIDGET_STORAGE_KEY;
    localStorage.setItem(storageKey, JSON.stringify(widgets));
    localStorage.setItem(LAST_SYNC_KEY, Date.now().toString());
  } catch (error) {
    console.error('Error saving widgets:', error);
  }
};

export const clearWidgets = (userId = null) => {
  try {
    const storageKey = userId ? `${WIDGET_STORAGE_KEY}_${userId}` : WIDGET_STORAGE_KEY;
    localStorage.removeItem(storageKey);
    localStorage.removeItem(LAST_SYNC_KEY);
  } catch (error) {
    console.error('Error clearing widgets:', error);
  }
};

export const shouldSyncWithBackend = () => {
  try {
    const lastSync = localStorage.getItem(LAST_SYNC_KEY);
    if (!lastSync) return true;
    
    const timeSinceLastSync = Date.now() - parseInt(lastSync);
    return timeSinceLastSync > SYNC_INTERVAL;
  } catch (error) {
    return true; // Sync on error
  }
};

export const getUserId = () => {
  try {
    const authData = JSON.parse(localStorage.getItem('authData') || '{}');
    return authData?.user?._id;
  } catch (error) {
    return null;
  }
};

export const isAuthenticated = () => {
  try {
    const authData = JSON.parse(localStorage.getItem('authData') || '{}');
    return !!(authData?.accessToken && authData?.user);
  } catch (error) {
    return false;
  }
};